import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { Button } from "@/components/ui/button"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

type DuplicateWarningBannerProps = {
  primaryPatientId: string
}

const DuplicateWarningBanner = ({ primaryPatientId }: DuplicateWarningBannerProps) => {
  const { t } = useTranslation()
  const country = useCountryParam()

  const handleOpenPrimaryPatient = () => {
    window.open(`/patients/${country}/${primaryPatientId}`, primaryPatientId)
  }

  return (
    <Banner
      variant="warning"
      type="full-width"
      className="py-1"
      iconClassName="pt-2"
      data-testid="duplicate-warning-banner">
      <span className="text-sm leading-5">{t("patient.duplicateWarningBanner.message")}</span>
      <Button
        variant="tertiary"
        className="text-on-warning-surface ml-auto"
        onClick={handleOpenPrimaryPatient}
        data-testid="open-primary-patient-button">
        {t("patient.duplicateWarningBanner.openPrimaryPatient")}
      </Button>
    </Banner>
  )
}

export { DuplicateWarningBanner }
